module.exports = __webpack_public_path__ + "static/img/green-info.b48ec8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/green-info.png
// module id = BTqa
// module chunks = 2